import { render } from "./ReviewComponents.vue?vue&type=template&id=dd583f7a&scoped=true"
import script from "./ReviewComponents.vue?vue&type=script&lang=js"
export * from "./ReviewComponents.vue?vue&type=script&lang=js"

import "./ReviewComponents.vue?vue&type=style&index=0&id=dd583f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd583f7a"]])

export default __exports__